'use strict';
import { cn_parking_space } from '../model/cn_parking_space';
import { cn_svg_map } from './cn_svg_map';
import { cn_mouse_event } from './cn_mouse_event';
import { cn_edit_box } from './cn_edit_box';
import { cn_parking_space_input } from './cn_inputs';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_pastille, cn_polygon_handler } from '..';

export class cn_parking_space_handler extends cn_edition_handler {
    //***********************************************************************************
    /**
     * Constructor
     * @param {Array<cn_parking_space>} parking_spaces
     * @param {cn_svg_map} map
     * @param {boolean} creation
     */
    constructor(parking_spaces, map, creation = false) {
        super(parking_spaces, map);

        this._map = map;
        this._scene = this._map._scene;
        this._transaction_manager = this._map._building.transaction_manager;

        //*** parking_space
        this.parking_spaces = parking_spaces;
        this._parking_space = (parking_spaces.length > 1) ? null : parking_spaces[0];
        if (this._parking_space) this._initialize_edition();

        this._current_vertex_index = 0;



        //*** Edit box for mass selection */
        const edit_box = new cn_edit_box(this, parking_spaces, this._readOnly);
        this._handlers.push(edit_box);
        const obj = this;

        if (!this._readOnly) {

            //*** width pastille */
            const parking_size_pastille = new cn_pastille([0, 0], 'arrow_all.svg');
            edit_box.add_pastille(parking_size_pastille);
            parking_size_pastille.svg_class = 'pastille_background white';
            parking_size_pastille.title = 'Dimensions de place de parking';
            parking_size_pastille.clicked = () => {
                const input = new cn_parking_space_input('Dimensions de place de parking', parking_spaces[0].angle, parking_spaces[0].widths[0], parking_spaces[0].widths[1], parking_spaces[0].length);
                if (parking_spaces.some(s => s.widths[0] != input.width || s.widths[1] != input.width_pmr || s.angle != input.angle || s.length != input.length))
                    input.label += ' (variable)';
                input.callback = () => {
                    obj._transaction_manager.push_transaction('Largeur de place de parking');
                    parking_spaces.forEach(parking_space => {
                        obj._transaction_manager.push_item_set(parking_space, ['widths', 'length', 'angle']);
                        parking_space.widths[0] = input.width;
                        parking_space.widths[1] = input.width_pmr;
                        parking_space.length = input.length;
                        parking_space.angle = input.angle;
                    });
                    map.refresh();
                };
                map.call('parking_space_input', input);
            }

            //*** Type pastille */
            edit_box.add_lock_pastille(this._transaction_manager);
        }
        edit_box.add_select_siblings_pastille('element_type');
    }

    //***********************************************************************************
    //**** Draws
    //***********************************************************************************
    draw(camera) {
        var html = '';

        if (this._parking_space) {
            if (this._mouseover_space >= 0)
                html += this._parking_space.draw_parking_space(camera, this._mouseover_space);
            html += this._parking_space.draw(camera, ['selected']);
        }

        if (this._handler) this._handler.visible = this._handler.active = !this._parking_space.locked;

        html += super.draw(camera);

        return html;
    }

    //***********************************************************************************
    //**** clear move effects
    //***********************************************************************************
    /**
     * Manage a passive move. To return 'true' if something of interest under the mouse.
     * @param {cn_mouse_event} ev
     * @returns  {boolean}
     */
    move(ev) {
        this._mouseover_space = -1;
        if (super.move(ev)) return true;

        const res = this._parking_space && this._parking_space.contains(ev.mouse_world);
        if (!res) return res;
        this._mouseover_space = this._parking_space.find_space_index(ev.mouse_world);
        return res;
    }

    grab(ev) {
        if (super.grab(ev)) return true;
        return this._mouseover_space >= 0;
    }

    click(ev) {
        if (super.click(ev)) return true;
        if (this._mouseover_space >= 0) {
            this._transaction_manager.push_transaction('Place de parking handicapé');
            this._transaction_manager.push_item_set(this._parking_space, ['indices']);
            while (this._parking_space.indices.length <= this._mouseover_space) this._parking_space.indices.push(0);
            this._parking_space.indices[this._mouseover_space] = 1 - this._parking_space.indices[this._mouseover_space];
        }
        return true;
    }

    _initialize_edition() {
        this._edit_parking_space(this._parking_space);
    }

    /**
     *
     * @param {cn_parking_space} parking_space
     */
    _edit_parking_space(parking_space) {
        this._handler = null;

        var obj = this;
        var scene = obj._scene;

        const handler = new cn_polygon_handler(this, parking_space.vertices, false);
        this._handler = handler;
        this._handlers.push(handler);
        handler.accept_outside = true;
        handler.snap_elements = scene.spaces.concat(scene.parking_spaces);
        handler.snap_elements.splice(handler.snap_elements.indexOf(parking_space), 1);

        if (this._map.get_readonly()) {
            return;
        }

        //*** Callback on change */
        handler.on('change', () => {
            obj._transaction_manager.push_transaction('Modification de place de parking', parking_space.ID);
            obj._transaction_manager.push_item_set(obj._parking_space, 'vertices');
            parking_space.vertices = handler.vertices;
        });
    }

}

